module.exports = __webpack_public_path__ + "img/Perks-Gift-10.ef3212e0.png";